/**
 * 表单控件的maker的公共方法
 * wangz 
 * 2018.3.9
 */

"use strict"
import { Form, Input, message } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './FormCtlMKComm'
const FormItem = Form.Item;

/**
 * 根据描述创建文本框
 * @param {父组件} panelModule 
 * @param {组件描述} moduleDesc 
 * @param {绑定实例ID} bdInst 
 * @param {当前工作区} ws 
 * @param {make类型} type 
 */
function text_mk(panelModule, moduleDesc, bdInst, workspace, type) {
    tool.sgiLogger.log(this);
    var formItemProps = { style: {} }; //input外层属性
    var inputprops = { style: {} }; //转换后属性
    //转换基础属性
    AddInputAttribute(moduleDesc, formItemProps, inputprops);
    //转换form公共属性
    AddFormCtlCommonAttribute(moduleDesc, formItemProps, inputprops);
    //设置布局
    setFormCtlLayout(moduleDesc, formItemProps, inputprops);
    //绑定事件
    bindEvent(moduleDesc, formItemProps, inputprops);
    //绑定值
    bindValue(panelModule, moduleDesc, bdInst, formItemProps, inputprops);

    tool.sgiLogger.log(formItemProps);
    tool.sgiLogger.log(inputprops);

    var c = moduleDesc.c;
    var resultJsx;
    if (bdInst && panelModule.state && panelModule.state[bdInst]) {
        resultJsx = (<FormItem {...formItemProps}><Input {...inputprops} value={panelModule.state[bdInst][c]} /></FormItem>)
    } else {
        resultJsx = (<FormItem {...formItemProps}><Input {...inputprops} /></FormItem>)
    }
    return resultJsx;
}



/**
 * 属性转换
 * @param {描述信息} moduleDesc 
 * @param {属性} formItem 
 * @param {属性} inputprops 
 */
var AddInputAttribute = function (moduleDesc, formItem, inputprops) {

    //csstyle 样式文件?这个我还不知道怎么用
    var csstyle = moduleDesc.csstyle;

    //是否是密码控件 这个暂时不用
    var isPwd = moduleDesc.isPwd;
}



export { text_mk };
export default text_mk;

//import * as constants from './constants';
//import {A, B} from './constants';
//export * from 'UBCtlMaker';
//export * as someIdentifier from "UBCtlMaker";



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/formCtlMK/SgiTextMaker.js